<template>
  <div>
    <!-- barra -->
    <v-app-bar
      app
      dark
      absolute
      color="primary"
      elevation="3"
      height="66"
      extension-height="52"
    >
      <!-- fecha -->
      <v-row align="center" class="pt-5">
        <v-col class="pa-0 flex-grow-0 flex-shrink-1">
          <v-btn icon to="/">
            <v-icon>chevron_left</v-icon>
          </v-btn>
        </v-col>
        <v-col class="pa-0 flex-grow-0 mr-2 display-2">
          {{ fecha.dia }}
        </v-col>
        <v-col class="pa-0 flex-grow-1">
          <v-row class="ma-0 overline">{{ fecha.nombreMes }}</v-row>
          <v-row class="ma-0 body-1">{{ fecha.nombreDia }}</v-row>
        </v-col>
        <v-col class="pa-0 flex-grow-0 flex-shrink-1">
          <v-menu v-model="showMenu" :close-on-content-click="false" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-card width="300px" class="pa-4 mb-0">
              <v-slider
                :label="t.config.tamLetra"
                v-model="ucMddTam"
                min="1"
                max="5"
                step="1"
                tick-size="1"
              ></v-slider>
            </v-card>
          </v-menu>
        </v-col>
      </v-row>

      <!-- pasos -->
      <template v-slot:extension>
        <v-container class="pa-0">
          <v-row align="center" class="ml-0 my-0">
            <!-- boton atras -->
            <v-btn
              class="ml-0 mr-3"
              small
              :disabled="!activeIconAtras"
              icon
              @click="pasoAnterior()"
            >
              <v-icon
                color="yellow lighten-4"
                v-text="audioIsPlaying ? 'replay_5' : 'undo'"
              ></v-icon>
            </v-btn>

            <!-- paso -->
            <div class="title yellow--text text--lighten-4 mr-2">
              {{ t.mdd.paso }} {{ numPaso }}
            </div>

            <!-- play pause -->
            <v-btn
              :disabled="!audioCanPlay"
              icon
              @click.stop="playPauseToogle()"
            >
              <v-icon color="yellow lighten-4">{{ audioIcon }}</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <!-- btn borrar -->
            <v-btn
              v-show="control === 5"
              :disabled="!tieneHl"
              icon
              @click.stop="
                modoLecturas = modoLecturas === 'eliminar' ? '' : 'eliminar'
              "
            >
              <v-icon
                :color="
                  modoLecturas === 'eliminar' ? 'yellow lighten-4' : 'white'
                "
              >
                delete_sweep
              </v-icon>
            </v-btn>

            <!-- btn marcar -->
            <v-btn
              v-show="control === 5"
              :disabled="!haySelect"
              icon
              @click.stop="selectAction($event, 'marcar')"
            >
              <v-icon>text_format</v-icon>
            </v-btn>
          </v-row>

          <!-- barra de progreso -->
          <v-row class="mx-n4">
            <v-progress-linear
              :color="barProgressColor"
              class="ma-0"
              height="4"
              :indeterminate="audioWaiting"
              :value="barProgressValue"
            />
          </v-row>
        </v-container>
      </template>
    </v-app-bar>

    <!-- contenidos -->
    <v-content
      id="pag-dcon"
      v-touch="{
        left: () => swipe('izq'),
        right: () => swipe('der')
      }"
    >
      <!-- Pasos DIA -->
      <v-container v-if="esDia" class="pa-sm-4 pa-lg-5">
        <!-- paso 1 -->
        <mdd-paso-oracion
          id="praystep-1"
          :control="control"
          :num="1"
          :step="pasos[1]"
        >
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn color="primary" @click.stop="pasoSiguiente()">
                <v-icon left>done</v-icon>
                {{ t.app.siguiente }}
              </v-btn>
            </v-col>
          </v-row>
        </mdd-paso-oracion>

        <!-- paso 2 -->
        <mdd-paso-oracion
          id="praystep-2"
          :control="control"
          :num="2"
          :step="pasos[2]"
        >
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn color="primary" @click.stop="pasoSiguiente()">
                <v-icon left>done</v-icon>
                {{ t.app.siguiente }}
              </v-btn>
            </v-col>
          </v-row>
        </mdd-paso-oracion>

        <!-- paso 3 -->
        <mdd-paso-oracion
          id="praystep-3"
          :control="control"
          :num="3"
          :step="pasos[3]"
        >
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn color="primary" @click.stop="pasoSiguiente()">
                <v-icon left>done</v-icon>
                {{ t.app.siguiente }}
              </v-btn>
            </v-col>
          </v-row>
        </mdd-paso-oracion>

        <!-- paso 4 -->
        <mdd-paso-oracion
          id="praystep-4"
          :control="control"
          :num="4"
          :step="pasos[4]"
        >
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn color="primary" @click.stop="pasoSiguiente()">
                <v-icon left>done</v-icon>
                {{ t.app.siguiente }}
              </v-btn>
            </v-col>
          </v-row>
        </mdd-paso-oracion>

        <!-- paso 5 - lecturas -->
        <mdd-paso-lecturas
          id="praystep-5"
          :num="5"
          :control="control"
          :hl="lngVerHls"
          :lectio="lectio"
          :step="pasos[5]"
          :modo="modoLecturas"
          @siguiente="pasoSiguiente()"
          @eliminar="eliminarHl($event)"
        >
        </mdd-paso-lecturas>

        <!-- paso 5 - cuaderno -->
        <v-dialog
          scrollable
          fullscreen
          persistent
          :width="appSizes.width + 'px'"
          :value="control === 6"
        >
          <!-- paso 5 - escribe -->
          <v-card :color="userColor" height="100vh">
            <v-card-title class="pa-0">
              <v-container>
                <v-row class="ma-0 pa-0">
                  <v-btn class="my-0 mr-2" icon @click.stop="pasoAnterior()">
                    <v-icon>undo</v-icon>
                  </v-btn>
                  <span>
                    {{ t.cuaderno.deOracion }}
                  </span>
                </v-row>
              </v-container>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <mdd-paso-escribe
                :doc-id="docId"
                :uid-local="uidLocal"
                :lectioCod="lectioCod"
                :step="pasos[5]"
                @siguiente="pasoSiguiente()"
                @anterior="pasoAnterior()"
              ></mdd-paso-escribe>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- paso 5 - profundiza -->
        <mdd-paso-profundiza
          id="praystep-7"
          :num="7"
          :control="control"
          :lectio="lectio"
          :step="pasos[5]"
        >
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn color="primary" @click.stop="pasoSiguiente()">
                <v-icon left>done</v-icon>
                {{ t.app.siguiente }}
              </v-btn>
            </v-col>
          </v-row>
        </mdd-paso-profundiza>

        <!-- paso 6 -->
        <mdd-paso-oracion
          id="praystep-8"
          :control="control"
          :num="8"
          :step="pasos[6]"
        >
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn color="primary" @click.stop="pasoSiguiente()">
                <v-icon left>done</v-icon>
                {{ t.app.siguiente }}
              </v-btn>
            </v-col>
          </v-row>
        </mdd-paso-oracion>

        <!-- pasos 7 -->
        <mdd-paso-oracion
          id="praystep-9"
          :control="control"
          :num="9"
          :step="pasos[7]"
        >
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn color="primary" @click.stop="terminar()">
                <v-icon left>done_all</v-icon>
                Terminar
              </v-btn>
            </v-col>
          </v-row>
        </mdd-paso-oracion>
      </v-container>

      <!-- Pasos NOCHE -->
      <v-container v-else class="pa-sm-4 pa-lg-5">
        <!-- paso 8 y oracion noche -->
        <mdd-paso-oracion :control="control" :num="1" :step="pasos[8]">
          <v-container class="mb-4">
            <!-- paso oracion de la noche -->
            <v-row>
              <h4 class="cyan--text font-italic">{{ t.mdd.oracionNoche }}</h4>
              <div class="font-italic" v-html="lectio.oraNoche"></div>
            </v-row>

            <!-- compromiso -->
            <v-row v-if="showCompromiso">
              <h4 class="cyan--text font-italic pb-0">
                {{ t.cuaderno.tuCompromHoy }}
              </h4>
            </v-row>
            <v-row v-if="showCompromiso">
              <v-col class="flex-grow-1 flex-shrink-0 pl-0 pt-0 font-italic">
                {{ txtCompromiso }}
              </v-col>
              <v-col class="flex-grow-0 flex-shrink-1">
                <v-btn icon @click="toggleCompromiso()">
                  <v-icon>{{ iconoCompromiso }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <!-- btn salir -->
            <v-row>
              <v-spacer></v-spacer>
              <v-col class="text-right">
                <v-btn color="primary" @click.stop="terminarNoche()">
                  <v-icon left>done_all</v-icon>
                  Terminar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </mdd-paso-oracion>
      </v-container>
    </v-content>

    <!-- audio -->
    <audio
      ref="audio"
      :src="audioSrc"
      @canplay="audioEvents"
      @canplaythrough="audioEvents"
      @durationchange="audioEvents"
      @ended="audioEvents"
      @loadstart="audioEvents"
      @play="audioEvents"
      @playing="audioEvents"
      @pause="audioEvents"
      @timeupdate="audioEvents"
      @waiting="audioEvents"
    ></audio>
  </div>
</template>

<script>
// import debounce from "lodash.debounce";
import appConfig from "../../mixs/mixAppConfig.js";
import userConfigEdit from "../../mixs/mixUserConfigEdit.js";
import MddPasoEscribe from "./MddPasoEscribe.vue";
import MddPasoLecturas from "./MddPasoLecturas.vue";
import MddPasoOracion from "./MddPasoOracion.vue";
import MddPasoProfundiza from "./MddPasoProfundiza.vue";
import { Touch } from "vuetify/lib/directives";

// import UserLibroApariencia from "./config/UserLibroApariencia";
import infoo from "../../plugins/infoo";

const rexHtmlLabels = RegExp(/<[^>]*>/g);

function dataSelect(textSelect, allText, allHtml, field) {
  // extraemos la informacion
  let cleanTextSelect = textSelect.replace(/(\r\n|\n|\r)/g, "");
  let cleanAllText = allText.replace(/(\r\n|\n|\r)/g, "");
  let lenHtml = allHtml.length;
  let iniCleanTxt = cleanAllText.indexOf(cleanTextSelect);
  let lenCleanTxt = cleanTextSelect.length;

  // variables de comprobacion
  let isHtml = false;
  // contador de texto
  let countTxt = 0;
  // contador de texto encontrado
  let countTxtFinded = 0;

  // variables de salida
  let htmlAntes = 0;
  let htmlDespues = 0;

  // variable bucle etiquetas
  let infoHtml = {};
  let info = rexHtmlLabels.exec(allHtml);
  while (info !== null) {
    infoHtml[info.index] = info[0].length;
    info = rexHtmlLabels.exec(allHtml);
  }

  // recorremos allHtml hasta completar el tamaño del texto seleccionado
  let i = 0;
  while (i < lenHtml && countTxtFinded <= lenCleanTxt) {
    isHtml = infoHtml[i] !== undefined;

    if (isHtml) {
      // contar html
      if (countTxt <= iniCleanTxt) {
        htmlAntes = htmlAntes + infoHtml[i];
      } else {
        htmlDespues = htmlDespues + infoHtml[i];
      }
      // avanzamos en el bucle la cantidad de caracteres de la etiqueta
      i = i + infoHtml[i];
    } else {
      // contado caracteres
      if (countTxt >= iniCleanTxt) countTxtFinded++;
      countTxt++;
      i++;
    }
  }

  // data
  return {
    field: field,
    i: iniCleanTxt + htmlAntes, // iniCleanTxt
    e: iniCleanTxt + lenCleanTxt + htmlAntes + htmlDespues, // end - 2 porque 0 representa posicion
    text: textSelect
  };
}

function selectElementHl(node) {
  if (!node) return false;

  let parent = node.parentNode;
  let hasHlField = parent.hasAttribute("hl-field");
  let isHlContainer = parent.hasAttribute("hl-container");
  while (!(hasHlField || isHlContainer)) {
    parent = parent.parentNode;
    hasHlField = parent.hasAttribute("hl-field");
    isHlContainer = parent.hasAttribute("hl-container");
  }

  return isHlContainer ? false : parent;
}

const scrollOff = {
  // https://vuejs.org/v2/guide/custom-directive.html
  bind(el, b) {
    window.__canScroll = b.value;
  },

  update(el, b) {
    window.__canScroll = b.value;
  }
};

export default {
  name: "mdd-pagina-dia",
  components: {
    MddPasoEscribe,
    MddPasoLecturas,
    MddPasoOracion,
    MddPasoProfundiza
    // UserLibroApariencia
  },
  mixins: [appConfig, userConfigEdit],
  directives: { scrolloff: scrollOff, touch: Touch },
  created() {
    // let _this = this;
    // https://vuejs.org/v2/guide/computed.html
    document.onselectionchange = () => {
      let sel = document.getSelection();
      // if (sel.anchorNode !== null && sel.isCollapsed === false) {
      if (sel.isCollapsed) {
        this.haySelect = false;
      } else {
        this.haySelect = true;
        this.selectText = sel.toString();
        this.selectAnchor = sel.anchorNode;
        this.selectFocus = sel.focusNode;
      }
    };
  },
  destroyed() {
    document.onselectionchange = "";
  },
  mounted() {
    // si termino la oracion o no ha comenzado muestra 1
    // de lo contrario avanza hasta el ultimo paso
    if (this.esDia && this.userNote.cd > 0 && this.userNote.cd < 9) {
      this.control = this.userNote.cd;
    }
  },
  data() {
    return {
      // pasos
      control: 1,
      // audio
      audioAutoStart: false,
      audioCanPlay: false,
      audioDuration: 0,
      audioIsPlaying: false,
      audioIcon: "volume_up",
      audioProgress: 0,
      audioWaiting: false,
      barProgressColor: "cyan darken-2",
      // otros
      hayCambios: false,
      haySelect: false,
      showMenu: false,
      // cuaderno
      colors: [
        "pink",
        "purple",
        "deep-purple",
        "indigo",
        "blue",
        "light-blue",
        "cyan",
        "teal",
        "green",
        "light-green",
        "lime",
        "yellow",
        "amber",
        "orange",
        "deep-orange",
        "blue-grey"
      ],
      // modos de interaccion
      modoLecturas: "",
      selectText: false,
      selectAnchor: {},
      selectFocus: {}
    };
  },
  computed: {
    appSizes() {
      return this.$store.getters["app/sizes"];
    },
    audioSrc() {
      return this.audios[this.control];
    },
    audios() {
      let pathCod = "/by_use/audios/" + this.lectioCod + "/";
      let pathLng = "/by_use/audios/" + this.lectio.lng + "/";
      let audioSanto = this.userConfig.orm.san; // pendiente consultar userConfig
      let audioRefl = audioSanto ? "-lecturas.mp3" : "-lecturas.mp3"; // "-santo-lecturas.mp3"

      let lstDia = [];
      lstDia[1] = pathLng + "paso-1.mp3";
      lstDia[2] = pathLng + "paso-2.mp3";
      lstDia[3] = pathLng + "paso-3.mp3";
      lstDia[4] = pathLng + "paso-4.mp3";
      lstDia[5] = "/by_use/audios/paso-5.mp3";
      lstDia[6] = "/by_use/audios/paso-5.mp3";
      lstDia[7] = "/by_use/audios/paso-5.mp3";
      lstDia[8] = pathLng + "paso-6.mp3";
      lstDia[9] = pathLng + "paso-7.mp3";

      let lstLicenseDia = [];
      lstLicenseDia[1] = pathLng + "paso-1.mp3";
      lstLicenseDia[2] = pathLng + "paso-2.mp3";
      lstLicenseDia[3] = pathLng + "paso-3.mp3";
      lstLicenseDia[4] = pathLng + "paso-4.mp3";
      lstLicenseDia[5] = pathCod + this.lectioCod + this.docId + audioRefl;
      lstLicenseDia[6] = "/by_use/audios/paso-5.mp3";
      lstLicenseDia[7] = pathCod + this.lectioCod + this.docId + "-reflex.mp3";
      lstLicenseDia[8] = pathLng + "paso-6.mp3";
      lstLicenseDia[9] = pathLng + "paso-7.mp3";

      let lstLicenseNoche = [];
      lstLicenseNoche[1] = pathLng + "paso-8.mp3";
      lstLicenseNoche[2] = pathCod + this.lectioCod + this.docId + "-noche.mp3";

      let lstNoche = [];
      lstNoche[1] = pathLng + "paso-8.mp3";

      let hasLicenseActive = false;
      if (hasLicenseActive) {
        return this.esDia ? lstLicenseDia : lstLicenseNoche;
      } else {
        return this.esDia ? lstDia : lstNoche;
      }
    },
    barProgressValue() {
      if (this.audioIsPlaying) {
        return (100 / this.audioDuration) * this.audioProgress;
      } else {
        return (100 / this.cantidadPasos) * this.control;
      }
    },
    cantidadPasos() {
      return this.esDia ? 9 : 2;
    },
    color() {
      return this.colors[this.cuaderno.color];
    },
    completados() {
      // si progreso en su camino de oracion del dia
      return this.esDia ? this.userNote["cd"] || 0 : this.userNote["cn"] || 0;
    },
    cuaderno() {
      return this.userConfig.cua;
    },
    docId() {
      let prms = this.$route.params;
      let date = new Date(prms.anio, prms.mes - 1, prms.dia, 0, 0, 0);
      return date.toISOString().slice(0, 10);
    },
    esDia() {
      return this.$route.params.filter === "dia";
    },
    fecha() {
      let prm = this.$route.params;
      let infoFecha = infoo.fechaAMD(prm.anio, prm.mes, prm.dia);

      return {
        anio: infoFecha.anio,
        mes: infoFecha.mes,
        dia: infoFecha.dia,
        min: this.appContext.min,
        max: infoFecha.max,
        nombreDia: this.t.dias[infoFecha.diaSem],
        nombreMes: this.t.meses[infoFecha.mes]
      };
    },
    lectio() {
      let search = {
        uid: this.docId,
        lng: this.userConfig.mdd.lng,
        ver: this.userConfig.mdd.ver
      };
      return this.$store.getters["lectio/fromSearch"](search);
    },
    lectioCod() {
      return this.lectio.lng + this.lectio.ver;
    },
    numPaso() {
      return this.numsPasos[this.control];
    },
    numsPasos() {
      let dia = [];
      dia[1] = "1";
      dia[2] = "2";
      dia[3] = "3";
      dia[4] = "4";
      dia[5] = "5";
      dia[6] = "5";
      dia[7] = "5";
      dia[8] = "6";
      dia[9] = "7";

      let noche = [];
      noche[1] = "8";
      noche[2] = "8";
      return this.esDia ? dia : noche;
    },
    pasos() {
      return this.$store.getters["pasos/oracion"];
    },
    lngVerHls() {
      return this.userNote.hl && this.userNote.hl[this.lectioCod]
        ? this.userNote.hl[this.lectioCod]
        : { cant: 0 };
    },
    tieneHl() {
      return this.lngVerHls.cant > 0;
    },
    uidLocal() {
      return "user/" + this.userAuth.uid + "/notes/" + this.docId;
    },
    userAuth() {
      return this.$store.getters["user/auth"];
    },
    userColor() {
      return (
        this.colors[this.cuaderno.color] + " lighten-" + this.cuaderno.light
      );
    },
    userNote() {
      return this.$store.getters["user/notes/item"](this.docId);
    },
    showCompromiso() {
      return this.userConfig && this.userConfig.orn
        ? this.userConfig.orn.com
        : false;
    },
    txtCompromiso() {
      return this.userNote && this.userNote.com !== ""
        ? this.userNote.com
        : this.t.cuaderno.hoyNoComp;
    },
    iconoCompromiso() {
      let i = ["", "sentiment_dissatisfied", "done", "done_all"];
      let idx = this.userNote.cok;
      return this.userNote ? i[idx] : "";
    },
    activeIconAtras() {
      return this.audioIsPlaying || this.control !== 1;
    }
  },
  methods: {
    audioEvents(e) {
      // https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Media_events
      switch (e.type) {
        case "loadstart":
          this.audioCanPlay = false;
          this.audioWaiting = true;
          break;

        case "durationchange":
          this.audioDuration = e.srcElement.duration;
          break;

        case "canplay":
          this.audioCanPlay = true;
          this.audioWaiting = false;
          if (this.audioAutoStart) {
            // insertar una pausa
            this.$refs.audio.play();
          }
          break;

        case "play" || "playing":
          this.audioIcon = "pause";
          this.audioWaiting = false;
          this.audioIsPlaying = true;
          this.audioAutoStart = true;
          this.barProgressColor = "yellow lighten-3";
          break;

        case "pause":
          this.audioIsPlaying = false;
          this.audioAutoStart = false;
          this.audioIcon = "volume_up";
          this.barProgressColor = "cyan darken-2";
          break;

        case "ended":
          this.audioIcon = "volume_up";
          this.barProgressColor = "cyan darken-2";
          break;

        case "timeupdate":
          this.audioProgress = e.target.currentTime;
          break;

        case "waiting":
          this.audioWaiting = true;
      }
    },
    terminar() {
      // pausa y detiene autoplay
      this.$refs.audio.pause();
      this.$router.push({ name: "home" }).catch(() => {
        // console.log(e);
      });
    },
    terminarNoche() {
      // si es de noche y llega a 2 lo registra
      let obj = { id: this.docId, uidLocal: this.uidLocal, data: {} };
      obj.data["cn"] = 3;
      this.$store.commit("user/notes/update", obj);
      this.terminar();
    },
    playPauseToogle() {
      if (!this.audioCanPlay) return "";

      if (this.audioIcon === "volume_up") {
        this.$refs.audio.play();
      } else {
        this.$refs.audio.pause();
      }
    },
    selectAction(e, action) {
      if (this.selectText === null) return;

      let pElement1 = selectElementHl(this.selectAnchor);
      let pElement2 = selectElementHl(this.selectFocus);
      if (!pElement1 || !pElement2) return;

      // si elemento de incio y final son diferentes omite seleccion
      // esto indicaría que inicio la seleccion en una lectura y la terminó en otra
      if (pElement1.innerText !== pElement2.innerText) return;

      // variables para la funcion
      let textSelect = this.selectText;
      let allText = pElement1.innerText;
      let source = pElement1.getAttribute("hl-source");
      let allHtml = this.lectio[source];
      let field = pElement1.getAttribute("hl-field");

      // textSelect, allText, allHtml, field
      let info = dataSelect(textSelect, allText, allHtml, field);
      info.cl = "b"; // color elegido por el usuario
      // TODO: permitir cambiar esto en la configuracion
      // campo en la configuracion sera mdd.col

      if (action === "marcar" || action === "vdm") {
        this.noteUpdate = true;
        // payload: {id: "2020-03-30", action: "marcar o vdm" cod: "es o esco" info: {hlObject}}
        let payload = {
          info: info,
          action: action,
          docId: this.docId,
          uidLocal: this.uidLocal,
          lectioCod: this.lectioCod,
          lectio: this.lectio
        };
        this.$store.commit("user/notes/updateHl", payload);
        this.$store.commit("user/notes/extraerTxtsBiblicos", payload);
      }

      // cualquier accion termina limpiando select
      document.getSelection().removeAllRanges();
      document.getSelection().empty();
      this.hayCambios = true;
      this.haySelect = false;
      this.selectText = null;
    },
    eliminarHl(data) {
      // accion eliminar hls
      if (data === false) {
        this.modoLecturas = "";
        return;
      }

      this.hayCambios = true;

      data.docId = this.docId;
      data.uidLocal = this.uidLocal;
      data.lectioCod = this.lectioCod;
      data.lectio = this.lectio;

      if (this.tieneHl === 1) {
        this.modoLecturas = "";
      }

      this.$store.commit("user/notes/eliminarHl", data);
      this.$store.commit("user/notes/extraerTxtsBiblicos", data);
    },
    finalAumenta(cambio) {
      var sel = document.getSelection();
      var rango = sel.getRangeAt(0);
      var anchor = sel.anchorNode;
      rango.setEnd(anchor, cambio);
    },
    goTo() {
      // desplaza scroll para enfocar paso
      if (this.esDia && this.control !== 6) {
        let options = {
          duration: 750,
          easing: "easeInOutCubic",
          container: this.$root.$grefs.appContainer,
          offset: 24
        };
        let id = this.control;
        let target = "#praystep-" + id;
        // esperar que vue termine de renderizar
        this.$nextTick(function() {
          this.$vuetify.goTo(target, options);
        });
      }
    },
    goToField(v) {
      // desplaza scroll para enfocar field text
      let options = {
        container: this.$root.$grefs.appContainer,
        duration: 750,
        easing: "easeInOutCubic",
        offset: 24
      };
      let selector = "#" + v;
      this.$nextTick(function() {
        this.$vuetify.goTo(selector, options);
      });
      // esperar que vue termine de renderizar
    },
    pasoSiguiente() {
      this.control = this.control + 1;
      // mueve el scroll al inicio
      this.goTo();
    },
    pasoAnterior() {
      // si no esta escuchando audio o esta en el cuaderno === 6
      if (!this.audioIsPlaying || this.control === 6) {
        // retrocede un paso
        this.audioAutoStart = false;
        this.control = this.control - 1;
        this.goTo();
      } else {
        // si esta escuchando audio, retrocede 5 segundos
        if (this.$refs.audio.currentTime > 5) {
          this.$refs.audio.currentTime = this.$refs.audio.currentTime - 5;
        } else {
          this.$refs.audio.currentTime = 0;
        }
      }
    },
    toggleCompromiso() {
      if (this.userNote.com !== "") {
        this.$store.commit("user/notes/compromisoOk", {
          docId: this.userNote._uid,
          uidLocal: this.uidLocal
        });
      }
    },
    swipe(mov) {
      switch (mov) {
        case "izq":
          if (this.esDia) {
            if (this.control === 9) {
              // terminar
              this.terminar();
            } else {
              // avanzar
              this.pasoSiguiente();
            }
          } else {
            this.terminarNoche();
          }

          break;
        case "der":
          if (this.activeIconAtras) {
            if (this.audioIsPlaying) {
              this.playPauseToogle();
            } else {
              this.pasoAnterior();
            }
          }
          break;
      }
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    audioSrc() {
      let readyState = this.$refs.audio.readyState;
      if (readyState < 4) {
        // gestionar aquí los audios que se cargarán según el control
        try {
          this.$refs.audio.load();
        } catch (e) {
          // console.log(e);
        }
      }
    },
    control(ahora, antes) {
      // si avanza en la oracion lo registra
      if (ahora > antes) {
        if (this.control > this.completados) {
          let obj = { id: this.docId, uidLocal: this.uidLocal, data: {} };

          if (this.esDia) {
            obj.data["cd"] = this.control;
          } else {
            obj.data["cn"] = this.control;
          }

          this.$store.commit("user/notes/update", obj);
        }
      }
    }
  }
};
</script>
